import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const employeeService = {
    getEmployees: async() => {
        try {
            const response = await axiosInstance.get(API.employee.getAll(null,null));
            return response.data;
        } catch(error) {
            throw error;
        }
    },

    getEmployeeDetail: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.employeeGetById(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getCompensations: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.getCompensations(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getEmployement: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.getEmployment(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getDirectReports: async(supervisorId) => {
       try{
             const response = await axiosInstance.get(API.employee.getHierDirectReports(supervisorId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getCareerPaths: async(employeeId) =>{
        try{
             const response = await axiosInstance.get(API.careerPaths.getByEmployee(employeeId));
             return response.data;
        } catch(error){
            throw error;
        }
    },

    getAlternativePaths: async(employeeId) =>{
        try{
             const response = await axiosInstance.get(API.careerPaths.getAlternativePaths(employeeId));
             return response.data;
        } catch(error){
            throw error;
        }
    },

    async getPreviousReview(employeeId) {
        const res = await axiosInstance.get(API.performanceReview.getPreviousReview(employeeId));
        return res.data;
      },

    getSupervisors : async ( employeeId, jobTitleId) => {
        try{
                 const response = await axiosInstance.get(API.careerPaths.getSupervisors(employeeId,jobTitleId))
                 return response.data;
        } catch(error){
            throw error;
        }
    },

      createTransition : async(paylaod) => {
        try{
             const response = await axiosInstance.post(API.careerPaths.createTransitions, paylaod);
             return response.data;
        } catch( error ){
            throw error ;
        }
    }


}

// Use a default export
export default employeeService;